module.exports = __webpack_public_path__ + "static/media/lecture.34afb96f.svg";